import classNames from "classnames";
import {useMobileNavBar} from "../model/hooks/useMobileNavBar";
import {User} from "@/entities/user";
import {BasketButton} from "@/entities/basket";
import {useIsActiveRoute} from "@/shared/lib/hooks/useIsActiveRoute";
import {Link} from "@/shared/ui/Link";
import {Svg} from "@/shared/ui/Svg";
import styles from "./MobileNavBar.module.scss";

type Props = {
    hideMobileNavBar: boolean;
    user: User;
};

export const MobileNavBar = (
    {
        hideMobileNavBar,
        user,
    }: Props
) => {
    const items = useMobileNavBar({user});

    const isActiveRoute = useIsActiveRoute();

    if (hideMobileNavBar) return null;

    return (
        <div className={styles.mobileNavBar}>
            <div className={styles.wrapper}>
                {items.map(item => {
                    const itemClasses = classNames(
                        styles.item,
                        styles[item.id],
                        {
                            [styles.active]: isActiveRoute(item.href),
                        }
                    );
                    const content = (
                        <>
                            <div className={styles.icon}>
                                <Svg id={item.icon} className={styles[item.svgClassName] ?? styles.svgIcon} />
                                {item.badge && item.badgeClassName && (
                                    <div className={styles[item.badgeClassName]}>
                                        {typeof item.badge === "number" ? item.badge : null}
                                    </div>
                                )}
                            </div>
                            {item.title && (
                                <p className={styles.title}>{item.title}</p>
                            )}
                        </>
                    );

                    if (item.component === "basketButton") {
                        return (
                            <BasketButton key={item.id} className={itemClasses}>
                                <div onClick={item.onClick}>{content}</div>
                            </BasketButton>
                        );
                    }

                    if (item.component === "link") {
                        return (
                            <Link key={item.id} href={item.href} onClick={item.onClick} className={itemClasses}>
                                {content}
                            </Link>
                        );
                    }

                    return (
                        <button key={item.id} type={`button`} onClick={item.onClick} className={itemClasses}>
                            {content}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
